module.exports = __webpack_public_path__ + "img/4-4.19ef5842.png";